module.exports = __webpack_public_path__ + "static/media/creategroup.7d6c59c3.svg";